module.exports = __webpack_public_path__ + "img/icon-watch-2.ee523dc2.svg";